module.exports = __webpack_public_path__ + "img/ic-shipment-green.ae9e67ad.svg";